const button = {
  width: '100%',
  backgroundColor: '#A775C8',
  borderRadius: 18,
  borderWidth: 1,
  color: '#FFFFFF',
  height: 36,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderColor: '#A775C8',
  paddingHorizontal: 0,
  paddingVertical: 0,
};

const buttonDisabled = {
  backgroundColor: '#e5e5e5',
  borderColor: '#e5e5e5',
};

const buttonText = {
  fontSize: 14,
  lineHeight: 18,
  fontFamily: 'figtree-bold',
  color: '#FFFFFF',
  letterSpacing: 0,
};

const buttonTextDisabled = {
  color: '#FFFFFF',
};

const buttonDanger = {
  backgroundColor: '#d9534f',
  borderColor: '#d43f3a',
};

const buttonPrimary = {
  backgroundColor: '#337ab7',
  borderColor: '#2e6da4',
};

const buttonLilla = {
  width: '100%',
  backgroundColor: '#A775C8',
  borderRadius: 18,
};

const buttonFacebook = {
  width: '100%',
  backgroundColor: '#1878f3',
  color: '#FFFFFF',
  borderColor: '#1878f3',
};

const buttonFacebookText = {
  letterSpacing: 0.22,
};

const buttonGroup = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  // flex: 1
};

const bottomPosition = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  padding: 15,
  right: 0,
};

export {
  button,
  buttonDisabled,
  buttonText,
  buttonTextDisabled,
  buttonDanger,
  buttonPrimary,
  buttonFacebook,
  buttonFacebookText,
  buttonLilla,
  buttonGroup,
  bottomPosition,
};
